module.exports = __webpack_public_path__ + "static/media/delivery-scooter-boy.5374c1c4.png";